module.exports = __webpack_public_path__ + "img/backIcon.ec43ab75.png";